exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home[data-v-fae5bece] {\n  width: 900px;\n  margin: 0 auto;\n  padding: 25px 0;\n}\n.home > .banner[data-v-fae5bece] {\n  text-align: center;\n  padding: 25px 0;\n  margin: 25px 0;\n}\n", ""]);

// exports
